import { render, staticRenderFns } from "./ProductSalesAndBudgetGraph.vue?vue&type=template&id=074662d2&scoped=true&lang=pug&"
import script from "./ProductSalesAndBudgetGraph.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesAndBudgetGraph.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSalesAndBudgetGraph.vue?vue&type=style&index=0&id=074662d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074662d2",
  null
  
)

export default component.exports